import { render } from "./ResultView.vue?vue&type=template&id=40b3531e"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__